const UTILS = (() => {
  return {
    ConvertStringToJS(str) {
      var script = document.createElement("script");
      script.text = str;
      document.head.appendChild(script).parentNode.removeChild(script);
    },
    ConvertStringToHTML(str) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(str, 'text/html');
      return doc.body;
    },  
    Handleize(text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    FormatMoney(value) {
      return Shopify.formatMoney(value, document.body.dataset.moneyFormat);
    }
  };
})();

(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductQuickAdd', () => ({
      $section: null,
      $container: null,
      $atc_btn: null,
      init() {
        let am = this;
        document.addEventListener('init-ProductQuickAdd', (e) => {
          if (am.$section) return;
          am.$section = e.target;
          am.$container = am.$section.closest('.quickadd');
          am.$atc_btn = am.$section.querySelector('.button--add-to-cart');
          am.$atc_btn.addEventListener('addtocart-complete', (e) => {
            am.OnAddToCartComplete();
          });
          let t;
          window.addEventListener('resize', () => {
            clearTimeout(t);
            t = setTimeout(() => {
              am.UpdateImageWidth();
              am.Resize();
              alignQuickAddButtons();
            }, 120);
          });
        });
      },
      ShowProductVariants(e) {
        let am = this;
        am.UpdateImageWidth();
        am.$section.classList.add('show-variants');
        requestAnimationFrame(() => {
          am.Resize();
          setTimeout(() => am.Resize(), 200);
          setTimeout(() => am.Resize(), 400);
          setTimeout(() => alignQuickAddButtons(), 450);
        });
      },
      UpdateImageWidth() {
        let am = this;
        let $product = am.$section.closest('.product__thumbnail') || am.$section.closest('.thumbnail');
        if (!$product) return;

        let $variantImage = $product.querySelector('.selected-variant-image');
        if (!$variantImage) return;

        let imgs = Array.from($product.querySelectorAll('img:not(.selected-variant-image)'));
        if (!imgs.length) return;

        let $baseImage = imgs
          .map(img => ({ img, w: img.getBoundingClientRect().width, h: img.getBoundingClientRect().height }))
          .sort((a, b) => (b.w * b.h) - (a.w * a.h))[0].img;

        const apply = () => {
          const rect = $baseImage.getBoundingClientRect();
          if (!rect.width || rect.width < 50 || !rect.height || rect.height < 50) return false;
          $variantImage.style.width = `${Math.round(rect.width)}px`;
          $variantImage.style.height = `${Math.round(rect.height)}px`;
          return true;
        };

        requestAnimationFrame(() => {
          if (apply()) return;
          setTimeout(() => apply(), 60);
          setTimeout(() => apply(), 180);
        });
      },
      ChangeVariant(e) {
        let am = this;
        let $target = e.target;

        let $variantTitle = am.$section.querySelector('.selected-variant-title');
        if ($variantTitle) {
          $variantTitle.textContent = $target.dataset.variantTitle;
        }

        let $product = am.$section.closest('.product__thumbnail') || am.$section.closest('.thumbnail');
        if ($product) {
          let $mainImg = $product.querySelector('.image__container img:not(.secondary):not(.selected-variant-image)');
          if ($mainImg) {
            $mainImg.src = $target.dataset.image;
            $mainImg.srcset = '';
          }

          // Also update secondary image src to match variant
          let $secondaryImg = $product.querySelector('.image__container img.secondary');
          if ($secondaryImg) {
            $secondaryImg.src = $target.dataset.image;
            $secondaryImg.srcset = '';
          }

          // Mark card as variant-selected to suppress hover swap
          $product.classList.add('variant-selected');
          // Also mark inner product__thumbnail if $product is .thumbnail wrapper
          let $inner = $product.querySelector('.product__thumbnail');
          if ($inner) $inner.classList.add('variant-selected');
        }

        let $img = am.$section.querySelector('.selected-variant-image');
        if ($img) $img.src = $target.dataset.image;

        let $thumb = $target.closest('.product__thumbnail');
        if ($thumb) {
          $thumb.querySelectorAll('a').forEach(($a) => {
            $a.setAttribute('href', `${$target.dataset.url}`);
          });
        }

        am.$section.querySelector('.variant-price').textContent = $target.dataset.price;
      },
      OnAddToCartComplete(e) {
        let am = this;

        am.$section.querySelector('.variant-price').classList.remove('zoomOut');
        if (am.$section.querySelector('.quickadd__swatches')) {
          setTimeout(() => {
            am.$section.classList.remove('show-variants');

            // Restore hover swap state
            let $product = am.$section.closest('.product__thumbnail') || am.$section.closest('.thumbnail');
            if ($product) {
              $product.classList.remove('variant-selected');
              let $inner = $product.querySelector('.product__thumbnail');
              if ($inner) $inner.classList.remove('variant-selected');
            }
          }, 1000);
        }

        am.Resize();
        alignQuickAddButtons();
      },
      Resize() {
        let am = this;
        let $carousel = am.$section.closest('.slider-gallery');
        if (!$carousel) return;

        let flickity = Flickity.data($carousel);
        if (!flickity) return;
        flickity.resize();
      }
    }));
  });
})();


/*============================================================================
    REBUY
  ==============================================================================*/
document.addEventListener('DOMContentLoaded', function() {
  const cartFlyout = document.querySelector('[data-rebuy-cart-layout="double"] .rebuy-cart_flyout, [data-rebuy-cart-layout="double-right"] .rebuy-cart_flyout');
  if (cartFlyout) {
    cartFlyout.style.maxWidth = '800px';
    cartFlyout.style.width = '800px';
  }
});

(function () {
  var MESSAGE_TEXT = "Helps us take care of you if your package is lost or damaged in transit";
  var MESSAGE_ID = "bv-shipping-insurance-note";

  function getRoot() {
    return (
      document.querySelector('[data-rebuy-component-id="smart-cart"]') ||
      document.querySelector('.rebuy-cart__flyout') ||
      document.querySelector('[data-rebuy-cart]') ||
      document
    );
  }

  function findCheckoutArea(root) {
    return root.querySelector('[data-rebuy-component="checkout-area"]');
  }

  function findInsuranceLabel(root) {
    var els = root.querySelectorAll('label, div, p, span');
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || "").toLowerCase();
      if (t.indexOf("add shipping insurance") !== -1) return els[i];
    }
    return null;
  }

  function ensureNote() {
    var root = getRoot();
    var checkoutArea = findCheckoutArea(root);
    if (!checkoutArea) return;

    var insuranceExists = !!findInsuranceLabel(root);
    var existing = checkoutArea.querySelector("#" + MESSAGE_ID);

    if (!insuranceExists) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      var msg = document.createElement("div");
      msg.id = MESSAGE_ID;
      msg.className = "bv-shipping-insurance-note";
      msg.textContent = MESSAGE_TEXT;
      checkoutArea.insertBefore(msg, checkoutArea.firstChild);
    }
  }

  function runSoon() {
    setTimeout(ensureNote, 0);
    setTimeout(ensureNote, 150);
    setTimeout(ensureNote, 500);
  }

  document.addEventListener("rebuy:smartcart.ready", runSoon);
  document.addEventListener("rebuy:cart.change", runSoon);

  var obs = new MutationObserver(runSoon);
  obs.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runSoon);
  } else {
    runSoon();
  }
})();

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.quickadd__swatch, .quickadd__swatch-wrapper');
  if (!swatch) return;

  const form = swatch.closest('.product_quickadd--form');
  if (form) form.classList.add('has-variant-selected');
});


/*============================================================================
    USA MARKET — EXCLUDE VARIANTS
  ==============================================================================*/
(function () {
  const country = window.Shopify?.country || '';
  if (country !== 'US') return;

  const EXCLUDED_OPTION_LABELS = ['Refill Bare'];
  const EXCLUDED_VARIANT_IDS = ['43001071009905'];

  function hideExcludedVariants() {
    document.querySelectorAll('label.rebuy-size-label').forEach(label => {
      if (EXCLUDED_OPTION_LABELS.includes(label.textContent.trim())) {
        const wrapper = label.closest('.rebuy-product-options__button-swatch, .rebuy-size-swatch');
        if (wrapper) wrapper.style.cssText = 'display:none!important';
      }
    });

    document.querySelectorAll('select.rebuy-select option').forEach(opt => {
      if (EXCLUDED_VARIANT_IDS.includes(opt.value)) opt.remove();
    });

    document.querySelectorAll('input[type="radio"][name^="option"]').forEach(input => {
      if (EXCLUDED_OPTION_LABELS.includes(input.value)) {
        const wrapper = input.closest('li, .option-value, label, .swatch__container, [data-option-value]');
        if (wrapper) wrapper.style.cssText = 'display:none!important';
      }
    });

    document.querySelectorAll('select[name="id"] option').forEach(opt => {
      if (EXCLUDED_VARIANT_IDS.includes(opt.value)) opt.remove();
    });
  }

  function scheduleFilter() {
    hideExcludedVariants();
    setTimeout(hideExcludedVariants, 100);
    setTimeout(hideExcludedVariants, 300);
    setTimeout(hideExcludedVariants, 600);
    setTimeout(hideExcludedVariants, 1000);
    setTimeout(hideExcludedVariants, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFilter);
  } else {
    scheduleFilter();
  }

  document.addEventListener('rebuy:ready', hideExcludedVariants);
  document.addEventListener('rebuy:cart.change', hideExcludedVariants);

  const rebuyObserver = new MutationObserver(hideExcludedVariants);
  function attachObserver() {
    const target = document.querySelector('.rebuy-product-options') || document.body;
    rebuyObserver.observe(target, { childList: true, subtree: true });
    setTimeout(() => rebuyObserver.disconnect(), 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachObserver);
  } else {
    attachObserver();
  }
})();


/*============================================================================
    QUICKADD BUTTON ALIGNMENT
  ==============================================================================*/
function alignQuickAddButtons() {
  document.querySelectorAll('.collection-matrix, .jsFeaturedCollection').forEach(grid => {
    const items = Array.from(grid.querySelectorAll('.grid-item'));
    if (!items.length) return;

    items.forEach(item => {
      const caption = item.querySelector('.thumbnail__caption');
      if (caption) caption.style.paddingBottom = '';
    });

    const rows = [];
    let currentRow = [];
    let currentTop = null;

    items.forEach(item => {
      const top = Math.round(item.getBoundingClientRect().top);
      if (currentTop === null || Math.abs(top - currentTop) > 5) {
        if (currentRow.length) rows.push(currentRow);
        currentRow = [item];
        currentTop = top;
      } else {
        currentRow.push(item);
      }
    });
    if (currentRow.length) rows.push(currentRow);

    rows.forEach(row => {
      let maxContentHeight = 0;

      row.forEach(item => {
        const caption = item.querySelector('.thumbnail__caption');
        const quickadd = item.querySelector('.quickadd');
        if (!caption || !quickadd) return;
        const height = quickadd.getBoundingClientRect().top - caption.getBoundingClientRect().top;
        if (height > maxContentHeight) maxContentHeight = height;
      });

      row.forEach(item => {
        const caption = item.querySelector('.thumbnail__caption');
        const quickadd = item.querySelector('.quickadd');
        if (!caption || !quickadd) return;
        const height = quickadd.getBoundingClientRect().top - caption.getBoundingClientRect().top;
        const diff = maxContentHeight - height;
        if (diff > 1) caption.style.paddingBottom = (36 + diff) + 'px';
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(alignQuickAddButtons, 300);
  setTimeout(alignQuickAddButtons, 800);
  setTimeout(alignQuickAddButtons, 1500);
  setTimeout(alignQuickAddButtons, 3000);

  document.addEventListener('lazyloaded', () => {
    clearTimeout(window._aqabTimer);
    window._aqabTimer = setTimeout(alignQuickAddButtons, 100);
  });

  let scrollTimer;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(alignQuickAddButtons, 150);
  }, { passive: true });
});